/**
 * @generated SignedSource<<3bfeca0bb9e902eac5c5f7e4df1177b1>>
 * @relayHash b1e02ca7b094a1ff9aaf5a6b5ddc5a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type InlineCommentsQuery$variables = {
  pageId: string;
};
export type InlineCommentsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly permissionType: SitePermissionType | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      };
      readonly body: {
        readonly value: string;
      };
      readonly contentStatus: string;
      readonly createdAt: {
        readonly value: string;
      };
      readonly createdAtNonLocalized: string;
      readonly id: string;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      };
      readonly location: {
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineMarkerRef?: string | null;
        readonly inlineResolveProperties?: {
          readonly isDangling: boolean;
          readonly resolved: boolean;
          readonly resolvedFriendlyDate: string | null;
          readonly resolvedTime: AGG$Long | null;
          readonly resolvedUser: string | null;
        } | null;
        readonly inlineText?: string | null;
        readonly type: string;
      };
      readonly parentId: string | null;
      readonly permissions: {
        readonly isEditable: boolean;
        readonly isRemovable: boolean;
        readonly isResolvable: boolean;
      };
      readonly replies: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null;
          readonly displayName: string | null;
          readonly permissionType: SitePermissionType | null;
          readonly profilePicture: {
            readonly path: string;
          } | null;
        };
        readonly body: {
          readonly value: string;
        };
        readonly contentStatus: string;
        readonly createdAt: {
          readonly value: string;
        };
        readonly createdAtNonLocalized: string;
        readonly id: string;
        readonly links: {
          readonly editui: string | null;
          readonly webui: string | null;
        };
        readonly location: {
          readonly commentResolveProperties?: {
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineMarkerRef?: string | null;
          readonly inlineResolveProperties?: {
            readonly isDangling: boolean;
            readonly resolved: boolean;
            readonly resolvedFriendlyDate: string | null;
            readonly resolvedTime: AGG$Long | null;
            readonly resolvedUser: string | null;
          } | null;
          readonly inlineText?: string | null;
          readonly type: string;
        };
        readonly parentId: string | null;
        readonly permissions: {
          readonly isEditable: boolean;
          readonly isRemovable: boolean;
          readonly isResolvable: boolean;
        };
        readonly version: {
          readonly by: {
            readonly displayName: string | null;
          } | null;
          readonly number: number | null;
          readonly when: string | null;
        };
      } | null>;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly number: number | null;
        readonly when: string | null;
      };
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly space: {
        readonly id: string | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
          readonly targetType: string | null;
        } | null> | null;
      } | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type InlineCommentsQuery = {
  response: InlineCommentsQuery$data;
  variables: InlineCommentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v4 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "pageId"
    }
  ],
  "concreteType": "PaginatedContentListWithChild",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v3/*: any*/)
          ]
        },
        (v3/*: any*/)
      ]
    }
  ]
},
v5 = [
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ROOT"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "UNRESOLVED"
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v7 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v8 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v9 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v6/*: any*/)
},
v10 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v11 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v14 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v18 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v20 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v22 = {
  "kind": "ScalarField",
  "name": "when"
},
v23 = {
  "kind": "ScalarField",
  "name": "number"
},
v24 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v21/*: any*/)
      ]
    },
    (v22/*: any*/),
    (v23/*: any*/)
  ]
},
v25 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v28 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v30 = {
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v2/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ]
},
v31 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v21/*: any*/)
      ]
    },
    (v22/*: any*/),
    (v23/*: any*/)
  ]
},
v32 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v21/*: any*/),
    (v25/*: any*/),
    (v26/*: any*/),
    (v27/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "InlineCommentsQuery",
    "selections": [
      (v4/*: any*/),
      {
        "args": (v5/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v24/*: any*/),
              (v28/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v24/*: any*/),
                  (v28/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InlineCommentsQuery",
    "selections": [
      (v4/*: any*/),
      {
        "args": (v5/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v30/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v30/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b1e02ca7b094a1ff9aaf5a6b5ddc5a29",
    "id": "9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506",
    "metadata": {},
    "name": "InlineCommentsQuery",
    "operationKind": "query",
    "text": "query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}}"
  }
};
})();

(node as any).hash = "82d41657ba53df28146f886f7478ca62";

export default node;
